import { http } from '@/http/axios.js';

// 商品列表
export function getProductListAPI(params) {
  return http({
    url: '/adminapi/product/page',
    method: 'get',
    params
  })
}
// 商品详情
export function getProductDetailAPI(id) {
  return http({
    url: '/adminapi/product/detail',
    method: 'get',
    params: { id }
  })
}
// 删除商品
export function deleteProductAPI(id) {
  return http({
    url: '/adminapi/product/delete',
    method: 'post',
    data: { id }
  })
}
// 新增商品
export function addProductAPI(data) {
  return http({
    url: '/adminapi/product/add',
    method: 'post',
    data
  })
}
// 编辑商品
export function editProductAPI(data) {
  return http({
    url: '/adminapi/product/edit',
    method: 'post',
    data
  })
}
// 修改权重
export function editWeightAPI(data) {
  return http({
    url: '/adminapi/product/weight/edit',
    method: 'post',
    data
  })
}
// 修改状态
export function editStatusAPI(data) {
  return http({
    url: '/adminapi/product/status/edit',
    method: 'post',
    data
  })
}
